// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "f08642b09144a41fc29f15aa5ef89ded78ce7c2e/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};